import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  const allowed = roles.includes(user?.role);
  useEffect(() => { if (user && !allowed) toast.error("Cette page est réservée à d'autres profils."); }, [user, allowed]);
  if (!allowed) return <Navigate to="/app" replace />;
  return children;
}
